import React from "react";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({
  message,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  destructive = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onCancel}
        onKeyDown={() => {}}
      />
      <div className="relative bg-white rounded-xl shadow-lg p-6 max-w-sm w-full mx-4">
        <p className="text-sm text-gray-700 mb-6">{message}</p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            onClick={onCancel}
          >
            {cancelLabel || t("Annuler")}
          </button>
          <button
            type="button"
            className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors ${
              destructive ? "bg-red-500 hover:bg-red-600" : "bg-primary hover:bg-primary/90"
            }`}
            onClick={onConfirm}
          >
            {confirmLabel || t("Confirmer")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
